export const SET_PUBLICATION_LIST = 'app/Workspace/Publications/SET_PUBLICATION_LIST';
export const SET_PUBLICATION_HISTORY = 'app/Workspace/Publications/SET_PUBLICATION_HISTORY';
export const SET_PUBLICATIONS_SORT = 'app/Workspace/Publications/SET_PUBLICATIONS_SORT';
export const SET_PUBLICATIONS_SEARCH = 'app/Workspace/Publications/SET_PUBLICATIONS_SEARCH';
export const UPDATE_PUBLICATION_LIST = 'app/Workspace/Publications/UPDATE_PUBLICATION_LIST';
export const UPDATE_PUBLICATION_STATUS = 'app/Workspace/Publications/UPDATE_PUBLICATION_STATUS';
export const UPDATE_PUBLICATION_DETAIL = 'app/Workspace/Publications/UPDATE_PUBLICATION_DETAIL';
